<!-- 成立工作室流程Flow -->
<template>

        <section class="settled bgw">
            <div class="container">
                <div class="settledWarp">
                    <div class="hd">
                        <h3>成立工作室流程</h3>
                        <div class="more">
                            <a class="btn minBtn hoverBg" href="#">了解详情</a>
                        </div>
                    </div>
                    <div class="bd">
                        <ul>
                            <li class="on">
                                <a class="step">
                                    <div class="stepNum"></div>
                                    <div class="stepName">个人身份验证</div>
                                </a>
                            </li>
                            <li>
                                <a class="step">
                                    <div class="stepNum"></div>
                                    <div class="stepName">提交成立申请</div>
                                </a>
                            </li>
                            <li>
                                <a class="step">
                                    <div class="stepNum"></div>
                                    <div class="stepName">系统审核通过</div>
                                </a>
                            </li>
                            <li>
                                <a class="step">
                                    <div class="stepNum"></div>
                                    <div class="stepName">完善工作室信息</div>
                                </a>
                            </li>
                            <li>
                                <a class="step">
                                    <div class="stepNum"></div>
                                    <div class="stepName">完成工作室成立</div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

</template>
<script>
    export default {
        name: 'Flow'
    }
</script>